import { createTheme } from '@mui/material/styles';

// Official Talexo brand palette — sampled directly from the pixels of
// public/jeminy_logo.png (the book-icon mark), not guessed. Mirrors the
// `talexo.*` colors added to tailwind.config.js so MUI components (which
// don't see Tailwind classes) and Tailwind-styled components share the exact
// same brand identity instead of MUI silently falling back to its default
// blue (#1976d2) while Tailwind-styled parts of the same page use ad-hoc
// blue-600/indigo-600/purple-600.
const theme = createTheme({
    // Every page wraps its content in <Container maxWidth="xl">, and MUI's
    // default `xl` is 1536px. On a 2560px display that left 512px of dead gutter
    // down each side — the page looked like a narrow strip in the middle of the
    // screen. Raising `xl` to 1920 halves that while still capping the width, so
    // ultrawide monitors don't stretch layouts to 3440px.
    //
    // Only `xl` moves. The other values are MUI's defaults, restated explicitly
    // so a future edit can't silently shift `md` — the desktop/mobile nav switch
    // (`display: { xs: 'none', md: 'flex' }`) hangs off md=900. Note Tailwind has
    // its own separate `xl` (1280, see tailwind.config.js); this does not touch
    // `xl:` utility classes.
    breakpoints: {
        values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1920 },
    },
    palette: {
        primary: {
            main: '#0AAAE6',
            dark: '#0888B8',
            light: '#4DC3ED',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#6428AA',
            dark: '#4F1F87',
            light: '#8654C0',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#E68C1E',
        },
    },
});

export default theme;
